var adminThemeBreakpoints = {
    values: {
        xs: 0,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1900,
    },
};

export { adminThemeBreakpoints };
//# sourceMappingURL=breakpoints.js.map
